<div class="contact-informations">
  <app-contact-informations-item [title]="'contactInformations.writeUs.title' | translate">
    <app-small>{{ 'contactInformations.writeUs.description' | translate }}</app-small>
    <app-link [color]="'light'" [href]="'mailto:' + ('globals.contactData.email' | translate)">{{ 'globals.contactData.email' | translate }}</app-link>
  </app-contact-informations-item>
  <app-contact-informations-item [title]="'contactInformations.callUs.title' | translate">
    <app-small>
      {{ 'contactInformations.callUs.description' | translate }}<br />
      {{ 'globals.contactData.callUsHours' | translate }}
    </app-small>
    <app-link [color]="'light'" [href]="'tel:' + ('globals.contactData.phone' | translate | phone)">{{ 'globals.contactData.phone' | translate }}</app-link>
  </app-contact-informations-item>
</div>
